import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IUserPromiseLookupService } from "../IUserPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class UserPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.UserImpl>
  implements IUserPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getUser(code: string): Promise<CubiqTS.UserImpl>;
  abstract getUsers(ids: string[]): Promise<CubiqTS.UserImpl[]>;
  abstract getUsersByClientCode(clientCode: string): Promise<CubiqTS.UserImpl[]>;
  abstract getLoggedInUser(): Promise<CubiqTS.UserImpl>;
  abstract changePassword(
    oldPassword: string,
    newPassword: string,
    newPasswordConfirmation: string,
    adminRequested: boolean,
    userCd: string,
  ): Promise<any>;
  abstract isChangePasswordRequested(): Promise<boolean>;
}
